
import { defineComponent, onMounted, ref } from "vue";
import { useStore } from "vuex";

import Card3 from "@/components/cards/Card3.vue";
import ApiService from "@/core/services/ApiService";
import AddUserModal from "@/components/modals/general/AddUserModal.vue";

export default defineComponent({
  name: "connections",
  components: {
    Card3,
    AddUserModal,
  },
  setup() {
    const store = useStore();
    const groupUsers = ref([]);
    const groupUsers2 = ref([]);
    const groupUsersMeta = ref({});
    const groupUsersMeta2 = ref({});

    onMounted(() => {
      setTimeout(() => {
        getGroupUsers();
        getGroupUsers2();
      }, 1000);
    });

    const getGroupUsers = async () => {
      try {
        const { data } = await ApiService.get(
          `users/accounts?companygroupid=IN${store.getters.currentUser.data.group_owners}&admintype=2`
        );
        if (data.success) {
          groupUsers.value = data.data;
          groupUsersMeta.value = data.meta;
        } else {
          groupUsers.value = [];
          groupUsersMeta.value = {};
        }
      } catch (e) {
        groupUsers.value = [];
        groupUsersMeta.value = {};
      }
    };
    const getGroupUsers2 = async () => {
      try {
        const { data } = await ApiService.get(
          `users/accounts?companygroupid=IN${store.getters.currentUser.data.group_owners}&admintype=6`
        );
        if (data.success) {
          groupUsers2.value = data.data;
          groupUsersMeta2.value = data.meta;
        } else {
          groupUsers2.value = [];
          groupUsersMeta2.value = {};
        }
      } catch (e) {
        groupUsers2.value = [];
        groupUsersMeta2.value = {};
      }
    };
    const onAddUser = () => {
      getGroupUsers();
      getGroupUsers2();
    };
    return {
      onAddUser,
      groupUsers,
      groupUsers2,
      groupUsersMeta,
      groupUsersMeta2,
      getGroupUsers,
      getGroupUsers2,
    };
  },
});
